var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGroup29 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 48,
    viewBox: "0 0 53 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.953125,
    width: 51.3803,
    height: 48,
    rx: 6,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.333 35L16.333 31L20.333 27",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.333 25V27C34.333 28.0609 33.9116 29.0783 33.1614 29.8284C32.4113 30.5786 31.3939 31 30.333 31H16.333",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.333 13L34.333 17L30.333 21",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 23V21C16.333 19.9391 16.7544 18.9217 17.5046 18.1716C18.2547 17.4214 19.2721 17 20.333 17H34.333",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroup29, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Group 29.86bd8d70.svg";
export { ForwardRef as ReactComponent };